import { useMemo } from 'react';
import { gql, RecommendedChannelsDocument, useQuery } from '@graphql/reactQuery';

/*#__PURE__*/ gql(/* GraphQL */ `
  query RecommendedChannels {
    recommendedChannels {
      __typename
      memberCount
      channel {
        id
        name
        webappUri
        staticProfileImage {
          id
          url
        }
        profileImage {
          id
          url
        }
      }
      hasNewContent
    }
  }
`);

export function useRecommendedChannels() {
  const { data, isLoading, error } = useQuery(RecommendedChannelsDocument, {
    staleTime: 0,
  });

  const channels = data?.data.recommendedChannels ?? [];

  const isEmpty = useMemo(
    () => channels.length === 0 && !isLoading && !error,
    [channels.length, error, isLoading],
  );

  return { channels, isLoading, isEmpty };
}
